import { render, staticRenderFns } from "./CurrentSubjectsStudent.vue?vue&type=template&id=f03c3a76&scoped=true&"
import script from "./CurrentSubjectsStudent.vue?vue&type=script&lang=js&"
export * from "./CurrentSubjectsStudent.vue?vue&type=script&lang=js&"
import style0 from "./CurrentSubjectsStudent.vue?vue&type=style&index=0&id=f03c3a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03c3a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VSnackbar,VToolbar,VToolbarTitle})
